import {
  setChildren,
  setHsCodesError,
  setHsCodesLoading,
  setHsRoot,
  setHsRootLoading,
} from "../redux/hsCodesStore";
import axios from "axios";

export const fetchHsRoot = () => async (dispatch) => {
  dispatch(setHsRootLoading(true));
  try {
    const { data } = await axios.get(
      "https://customs-db.border.ly/nomenclature?parents=true&siblings=true&children=true",
    );
    dispatch(setHsRoot(data.results || []));
  } catch (err) {
    console.error("Failed to fetch root HS codes", err);
    dispatch(setHsCodesError(err.message));
  } finally {
    dispatch(setHsRootLoading(false));
  }
};

export const fetchHsChildren = (parentCode) => async (dispatch) => {
  try {
    const { data } = await axios.get(
      `https://customs-db.border.ly/nomenclature?hscode=${parentCode}&parents=true&siblings=true&children=true`,
    );
    dispatch(setChildren({ parentCode, children: data.children || [] }));
  } catch (err) {
    console.error("Failed to fetch child HS codes", err);
    dispatch(setHsCodesError(err.message));
  }
};
